import { BRAND } from '../styles/brand';

/**
 * Participatieladder van de Factor C-methode — de ladder die Leene hanteert.
 * Eén bron voor Fase 3 (persona's), Fase 4 (doelgroepen) en het dossier.
 * Spiegel van backend/services/participatie.js.
 */
export const PARTICIPATIE = ['Meeweten', 'Meedenken', 'Meewerken', 'Meebepalen'];

/** Oplopende intensiteit: licht → merkgroen. */
export const PARTICIPATIE_COLORS = [BRAND.tint, BRAND.randSterk, BRAND.groenMuted, BRAND.groen];
export const PARTICIPATIE_TEXT = [BRAND.groen, BRAND.groen, '#ffffff', '#ffffff'];

// Treden van de eerder gebruikte IAP2-ladder → Factor C (bestaande dossiers).
const LEGACY_MAP: Record<string, string> = {
  informeren: 'Meeweten',
  raadplegen: 'Meedenken',
  adviseren: 'Meedenken',
  coproduceren: 'Meewerken',
  meebeslissen: 'Meebepalen',
};

/** Normaliseer naar een Factor C-trede; onbekende waarden blijven staan (niets gaat verloren). */
export function normalizeParticipatie(value?: string): string {
  const raw = String(value || '').trim();
  const s = raw.toLowerCase();
  if (!s) return '';
  return PARTICIPATIE.find((p) => p.toLowerCase() === s) || LEGACY_MAP[s] || raw;
}
